var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoices-index width-100"},[_c('TableWrapper',{attrs:{"table-columns":_vm.invoicesColumns,"table-key":"invoices","enable-selection":false},on:{"showInvoice":_vm.showInvoice,"showAttachmentPdf":_vm.showAttachmentPdf,"showAttachmentXls":_vm.showAttachmentXls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }